const selectors = {
	productContainer: document.querySelector('.product-details-wrapper'),
	productMedia: document.querySelector('[data-productMedia]'),
};

const mediaJSON =
	selectors.productMedia !== null
		? JSON.parse(selectors.productMedia.innerHTML)
		: '';
window.productMedia = mediaJSON;

class TemplateProductJS {
	constructor() {
		// Custom code for product page goes here
		this._selectIooty();
		this._changeSlide();
		this._loafFeature();
	}

	_selectIooty = () => {
		document
			.querySelectorAll('.iotty-product[data-productHandle]')
			.forEach((btn) => {
				btn.addEventListener('click', (event) => {
					let handle = event.target
						.closest('[data-productHandle]')
						.getAttribute('data-productHandle');
					let reqUrl = `/products/${handle}?view=techspec`;

					fetch(reqUrl)
						.then((response) => response.text())
						.then((responseText) => {
							const html = responseText;
							this.renderProduct(html);
						});
				});
			});
	};

	renderProduct(html) {
		const productHTML = new DOMParser().parseFromString(html, 'text/html');

		document.querySelector('[data-iootyProduct]').innerHTML =
			productHTML?.querySelector('[data-iootyProduct]')?.innerHTML;

		this._selectIooty();
		this._changeSlide();
		this._loafFeature();
	}

	_changeSlide = () => {
		let featuretabs = document.querySelectorAll(
			'.product-descriptions [data-tabcontent]'
		);
		featuretabs.forEach((tab) => {
			tab.addEventListener('click', (event) => {
				let slide = event.target
					.closest('[data-tabcontent]')
					.getAttribute('data-tabcontent');
				slide = slide.replace('#', '');
				let product_media = document.querySelector(
					'[ data-productMedia]'
				).textContent;
				product_media = JSON.parse(product_media);
				product_media.forEach((media) => {
					if (media.alt == slide) {
						let imageID = media.id;
						let imageSlide = document.querySelector(
							`.product--media[data-mediaID="${imageID}"]`
						);

						if (imageSlide !== null) {
							let slideIndex = Array.from(
								imageSlide.parentNode.children
							).indexOf(imageSlide);

							if (productSlider) {
								productSlider.slideTo(slideIndex, 2000, true);
							}
						}
					}
				});
			});
		});
	};

	_loafFeature = () => {
		let loadFeature = document.querySelector('[data-loadFeature]');

		if (loadFeature === null) return;

		loadFeature.addEventListener('click', (e) => {
			let toggleContent = document.querySelectorAll('.more-five');
			let isClose = document
				.querySelector('.more-five')
				.classList.contains('hide-feature');
			if (isClose) {
				toggleContent.forEach((ele) => {
					ele.classList.remove('hide-feature');
				});
			} else {
				toggleContent.forEach((ele) => {
					ele.classList.add('hide-feature');
				});
			}
		});
	};
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
